import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useSchool } from '../../DataStore/SchoolContext';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    title: '',
    description: '',
    loading: false,
}

const EditFeesGroup = ({groupInfo}) => {

    const [info, setInfo] = useState(null);
    const {getFeesGroups, getFeesStructures} = useSchool();
    const [state, dispatch] = useReducer(reducer, initialState);
    const {closeSettings, setSystemFunction, setNotify} = useTheme();

    useEffect(()=>{
        if(groupInfo){
            dispatch({type: 'title', value: groupInfo.group_name});
            dispatch({type: 'description', value: groupInfo.description});
        }
    }, [groupInfo])

    useEffect(()=>{
        setSystemFunction(() => handleConfirm);
        return () => setSystemFunction(() => {});
    }, [state]);

    const handleConfirm = async () =>{
        dispatch({type: 'loading', value: true})
        const server_response = await ajaxSchool.updateFeesGroup(groupInfo.id, state.title, state.description);
        dispatch({type: 'loading', value: false})
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message} closable={false}/>);
            getFeesGroups(true);
            getFeesStructures(true);
            closeSettings();
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }


    return (
        <>
        <CallOut 
            title="Fees Groups"
            description="Fees groups help you bill multiple students at once. Assign students to a group and the system will automatically apply the correct fees to everyone in that group."
            />
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                    <TextInput
                      type='text'
                      label='Title'
                      placeholder='Group reference title'
                      leftIcon='fa fa-tag'
                      value={state.title}
                      onChange={e => dispatch({type: 'title', value: e.target.value})}
                      required
                      wrap
                    />


                    <TextInput
                      type='textarea'
                      label='Description'
                      placeholder='Description'
                      leftIcon='fa fa-list'
                      value={state.description}
                      onChange={e => dispatch({type: 'description', value: e.target.value})}
                      required
                      wrap
                    />

            
                </form> 

        </>
    );
};

export default EditFeesGroup;